import { ref } from "vue";

import type { ReleasableRef } from "@ctrl/controller-rpc";

import { Theme } from "@/composables/useTheme";
import { withRelease } from "@/ref";

/*
 * This composable tracks the theme defined by the operating system.
 *
 * The returned ref's `release()` removes the media-query listener.
 */

export function useSystemTheme(): Readonly<ReleasableRef<Theme>> {
  const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

  const themeOf = (matches: boolean): Theme => (matches ? "dark" : "light");
  const systemTheme = ref<Theme>(themeOf(mediaQuery.matches));

  // Track changes at the operating system level.
  const changeHandler = (event: MediaQueryListEvent) => {
    systemTheme.value = themeOf(event.matches);
  };
  mediaQuery.addEventListener("change", changeHandler);

  return withRelease(systemTheme, () =>
    mediaQuery.removeEventListener("change", changeHandler)
  );
}
